import axios from 'axios'
// import QS from 'qs'
import { Message } from 'element-ui'
// import router from '../router'

// 环境的切换
// if (process.env.NODE_ENV === 'development') {
//   axios.defaults.baseURL = ''
// } else if (process.env.NODE_ENV === 'debug') {
//   axios.defaults.baseURL = ''
// } else if (process.env.NODE_ENV === 'production') {
//   axios.defaults.baseURL = ''
// }

// axios.defaults.withCredentials = true
// 请求超时时间
axios.defaults.timeout = 30000

// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// 请求拦截器
// axios.interceptors.request.use(
//   config => {
//     // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
//     // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
//     const token = store.state.token
//     token && (config.headers.Authorization = token)
//     return config
//   },
//   error => {
//     return Promise.error(error)
//   })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data

    if (response.config.url.includes('/prod-api/')) {
      // 只针对/prod-api/
      if (res.code !== 0) {
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })

        return Promise.reject(res)
      }
    }
    // console.log(res.data)
    return Promise.resolve(res)
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// function get(url, params) {
//   return new Promise((resolve, reject) => {
//     axios.get('/dev-api' + url, {
//       params: params
//     })
//       .then(res => {
//         resolve(res.data)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }

const desBaseUrl = '/sq-api'

function getLark(url, params) {
  // https://qckxm6.api.cloudendpoint.cn/getWxQrStatus
  // const desBaseUrl = 'https://qckxm6.api.cloudendpoint.cn'
  return new Promise((resolve, reject) => {
    axios.get(desBaseUrl + url, {
      params: params
    })
      .then(res => {
        // resolve(res.data)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function getOrg(url, params) {
  return new Promise((resolve, reject) => {
    axios.get('/prod-api' + url, {
      params
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
function postOrg(url, data) {
  return new Promise((resolve, reject) => {
    axios.post('/prod-api' + url, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// function upload (url, formData) {
//   const headers = {
//     'content-type': 'multipart/form-data'
//   }
//   return new Promise((resolve, reject) => {
//     axios.post(url, formData, {headers})
//       .then(res => {
//         resolve(res.data)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }

export default {
  getWxQr(params) {
    // return get(`/share/wx/qr/get`, params)
    return getLark(`/getWxQr`, params)
  },
  getWxQrStatus(params) {
    // return get(`/share/wx/qr/status`, params)
    return getLark(`/getWxQrStatus`, params)
  },
  getQQQr(params) {
    // return get(`/share/qq/qr/get`, params)
    return getLark(`/getQQQr`, params)
  },
  getQQQrStatus(params) {
    // return get(`/share/qq/qr/status`, params)
    return getLark(`/getQQQrStatus`, params)
  },
  // getSmsCode (params) {
  //   return getLark('/getcode', params)
  // },
  // auth (params) {
  //   return getLark('/shouquan', params)
  // },
  sqPhoneSms(params) {
    // return get(`/share/phone/sms`, params)
    return getLark('/sqPhoneSms', params)
  },
  sqPhone(params) {
    // return get(`/share/phone/sq`, params)
    return getLark('/sqPhone', params)
  },
  getJrxyQr(params) {
    // return get(`/share/jrxy/qr/get`, params)
    return getLark(`/getJrxyQr`, params)
  },
  getJrxyQrStatus(params) {
    // return get(`/share/jrxy/qr/status`, params)
    return getLark(`/getJrxyQrStatus`, params)
  },
  viewBdlpRunTask(params) {
    return getLark(`/viewBdlpRunTask`, params)
  },
  getPacPath(params) {
    return getLark(`/getPacPath`, params)
  },
  validFace(key, file) {
    return new Promise((resolve, reject) => {
      axios.post(desBaseUrl + '/validFace', file, {
        headers: {
          'Content-Type': 'application/octet-stream',
          'Stu-Key': key
        }
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 直接到源服务器的请求
  viewRunTaskByToken(app, params) {
    return getOrg(`/${app}/run_task/view/token`, params)
  },
  viewStudentInfoByToken(app, params) {
    return getOrg(`/${app}/student/view/info/token`, params)
  },
  viewStudentInfoByPasswordCustomer(app, params) {
    return getOrg(`/${app}/student/view/info/password/customer`, params)
  },

  getOssToken(app, params) {
    return getOrg(`/${app}/student/oss/get`, params)
  },

  viewPhotoStore(app, params) {
    return getOrg(`/${app}/photo_store/view`, params)
  },

  addPhotoStore(app, data) {
    return postOrg(`/${app}/photo_store/add`, data)
  },
  changePhotoStore(app, data) {
    return postOrg(`/${app}/photo_store/change`, data)
  },

  viewSchool(app, params) {
    return getOrg(`/${app}/school/view`, params)
  },

  changePusher(app, data) {
    data.app = app
    return postOrg(`/remind/pusher/change`, data)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js